
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { ChevronLeft, PencilLine } from "lucide-react";
import { UserProfile } from "./types";

interface ProfileHeaderProps {
  profile: UserProfile;
  isOwnProfile: boolean;
  isEditing: boolean;
  setIsEditing: (isEditing: boolean) => void;
}

export const getInitials = (firstName: string | null, lastName: string | null) => {
  const first = firstName ? firstName[0] : "";
  const last = lastName ? lastName[0] : "";
  return (first + last).toUpperCase();
};

const ProfileHeader = ({ profile, isOwnProfile, isEditing, setIsEditing }: ProfileHeaderProps) => {
  const fullName = `${profile.first_name || ""} ${profile.last_name || ""}`.trim() || "User";

  return (
    <div className="mb-6">
      <Button variant="ghost" size="sm" asChild className="mb-4">
        <Link to="/" className="flex items-center gap-1">
          <ChevronLeft className="h-4 w-4" />
          Back
        </Link>
      </Button>
      
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-4">
          <Avatar className="h-16 w-16">
            <AvatarFallback className="text-xl">
              {getInitials(profile.first_name, profile.last_name)}
            </AvatarFallback>
          </Avatar>
          <div>
            <h1 className="text-2xl font-bold">
              {fullName}
              {profile.username && <span className="text-muted-foreground ml-2 text-lg">@{profile.username}</span>}
            </h1>
            <p className="text-muted-foreground">
              Member since {new Date(profile.created_at).toLocaleDateString()}
            </p>
          </div>
        </div>
        
        {isOwnProfile && !isEditing && (
          <Button 
            onClick={() => setIsEditing(true)}
            size="sm"
            className="flex items-center gap-1"
          >
            <PencilLine className="h-4 w-4" />
            Edit Profile
          </Button>
        )}
      </div>
    </div>
  );
};

export default ProfileHeader;
